<script setup lang="ts">
import { showLoadingToast, showToast } from "vant";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";

const urlParams = new URLSearchParams(window.location.search);
const { t } = useI18n();

onMounted(() => {
    try {
        const url = urlParams.get('url')
        console.log(url,'url--');
        
        if (!url) {
            showToast('url not found')
            return
        }
        showLoadingToast({
            message: t("Loading"),
            duration: 0,
        });
        url && window.location.replace(url);
    } catch (error) {
        console.error(JSON.stringify(error))
        showToast('Replace Error')
    }
})
</script>

<template>
  <div class="layout"></div>
</template>

<style lang="scss" scoped>
.layout {
  height: 100%;
  min-height: 100vh;
  background: #070b14;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
}
</style>
